import client from "lib/apolloClient/client";
import { deleteOrganizationResourceMutation } from "./WorkbookTemplateMutations";
import _ from "lodash";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import update from "immutability-helper";
import {
  getWorkbookSchoolTemplateFromCache,
  writeWorkbookSchoolTemplateFromCache,
  getWorkbookSchoolTemplateCountFromCache,
  writeWorkbookSchoolTemplateCounToCache,
} from "./WorkbookTemplateGraphqlHelpers";
import { isNewTemplateResolverEnabled } from "./Utils";

const getUpdatedDataAfterDeleteV1 = ({ id, data }) => {
  const edges = _.get(
    data,
    "node.workbookTemplates.organizationResource[0].childrenV2.edges"
  );
  const nodeIndex = _.findIndex(edges, edge =>
    _.isEqual(_.get(edge, "node.id"), id)
  );
  const totalCount = _.get(
    data,
    "node.workbookTemplates.organizationResource[0].childrenV2.resourceTypeBasedCount.totalCount"
  );
  const updatedTotalCount = totalCount - 1;
  return nodeIndex < 0
    ? data
    : update(data, {
        node: {
          workbookTemplates: {
            organizationResource: {
              0: {
                childrenV2: {
                  edges: {
                    $splice: [[nodeIndex, 1]],
                  },
                  resourceTypeBasedCount: {
                    totalCount: { $set: updatedTotalCount },
                  },
                },
              },
            },
          },
        },
      });
};

const getUpdatedCountDataAfterDeleteV1 = ({ data }) => {
  const totalCount = _.get(
    data,
    "node.workbookTemplates.organizationResource[0].childrenV2.resourceTypeBasedCount.totalCount"
  );
  const updatedTotalCount = totalCount - 1;
  return update(data, {
    node: {
      workbookTemplates: {
        organizationResource: {
          0: {
            childrenV2: {
              resourceTypeBasedCount: {
                totalCount: { $set: updatedTotalCount },
              },
            },
          },
        },
      },
    },
  });
};

const getUpdatedDataAfterDeleteV2 = ({ id, data }) => {
  const edges = _.get(
    data,
    "node.workbookTemplatesV2.workbookTemplateResource[0].childrenV2.edges"
  );
  const nodeIndex = _.findIndex(edges, edge =>
    _.isEqual(_.get(edge, "node.id"), id)
  );
  const totalCount = _.get(
    data,
    "node.workbookTemplatesV2.workbookTemplateResource[0].childrenV2.resourceTypeBasedCount.totalCount"
  );
  const updatedTotalCount = totalCount - 1;
  return nodeIndex < 0
    ? data
    : update(data, {
        node: {
          workbookTemplatesV2: {
            workbookTemplateResource: {
              0: {
                childrenV2: {
                  edges: {
                    $splice: [[nodeIndex, 1]],
                  },
                  resourceTypeBasedCount: {
                    totalCount: { $set: updatedTotalCount },
                  },
                },
              },
            },
          },
        },
      });
};

const getUpdatedCountDataAfterDeleteV2 = ({ data }) => {
  const totalCount = _.get(
    data,
    "node.workbookTemplatesV2.workbookTemplateResource[0].childrenV2.resourceTypeBasedCount.totalCount"
  );
  const updatedTotalCount = totalCount - 1;
  return update(data, {
    node: {
      workbookTemplatesV2: {
        workbookTemplateResource: {
          0: {
            childrenV2: {
              resourceTypeBasedCount: {
                totalCount: { $set: updatedTotalCount },
              },
            },
          },
        },
      },
    },
  });
};

const getUpdatedDataAfterDelete = params =>
  (isNewTemplateResolverEnabled()
    ? getUpdatedDataAfterDeleteV2
    : getUpdatedDataAfterDeleteV1)(params);

const getUpdatedCountDataAfterDelete = params =>
  (isNewTemplateResolverEnabled()
    ? getUpdatedCountDataAfterDeleteV2
    : getUpdatedCountDataAfterDeleteV1)(params);

export const deleteWorkbookTemplate = ({
  id,
  label,
  templateFilters,
  schoolTemplateFilters,
}) => {
  return async (dispatch, getState) => {
    const schoolTemplateData = getWorkbookSchoolTemplateFromCache(
      schoolTemplateFilters
    );
    const templateData = getWorkbookSchoolTemplateFromCache(templateFilters);
    const templatesCountData = getWorkbookSchoolTemplateCountFromCache(
      templateFilters
    );
    try {
      await client.mutate({
        mutation: deleteOrganizationResourceMutation,
        variables: {
          ids: [id],
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            deleteOrganizationResource: true,
          },
        },
        update: (
          cache,
          {
            data: {
              platform: { deleteOrganizationResource },
            },
          }
        ) => {
          if (deleteOrganizationResource) {
            setTimeout(() =>
              writeWorkbookSchoolTemplateFromCache({
                filters: schoolTemplateFilters,
                data: getUpdatedDataAfterDelete({
                  id,
                  data: schoolTemplateData,
                }),
              })
            );
            setTimeout(() =>
              writeWorkbookSchoolTemplateFromCache({
                filters: templateFilters,
                data: getUpdatedDataAfterDelete({
                  id,
                  data: templateData,
                }),
              })
            );
            setTimeout(() => {
              writeWorkbookSchoolTemplateCounToCache({
                filters: templateFilters,
                data: getUpdatedCountDataAfterDelete({
                  id,
                  data: templatesCountData,
                }),
              });
            });
          }
        },
      });
      dispatch(
        setToastMsg({
          msg: "workbook:template_delete_successfully_with_label",
          type: "success",
          position: "toast-bottom-left",
          locale_params: [{ key: "label", value: label, isPlainText: true }],
        })
      );
    } catch (e) {
      setTimeout(() => {
        writeWorkbookSchoolTemplateFromCache({
          filters: schoolTemplateFilters,
          data: schoolTemplateData,
        });
      });
      setTimeout(() =>
        writeWorkbookSchoolTemplateFromCache({
          filters: templateFilters,
          data: templateData,
        })
      );
      setTimeout(() => {
        writeWorkbookSchoolTemplateCounToCache({
          filters: templateFilters,
          data: templatesCountData,
        });
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};
